import React, { useEffect, useRef } from "react";

const WaveformVisualizer = ({ stream, isRecording , paused }) => {
  const canvasRef = useRef(null);
  const audioCtxRef = useRef(null);
  const analyserRef = useRef(null);
  const sourceRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    if (stream && isRecording) {
      // Create a new AudioContext
      audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();

      // Create an analyser node
      analyserRef.current = audioCtxRef.current.createAnalyser();
      analyserRef.current.fftSize = 2048;

      // Create a source node from the stream
      sourceRef.current = audioCtxRef.current.createMediaStreamSource(stream);
      sourceRef.current.connect(analyserRef.current);

      // Start drawing the waveform
      if (isRecording && !paused) {
        drawWaveform(); // Start drawing waveform when recording and not paused
      }
    }

    return () => {
      // Clean up audio context and animation frames when the component unmounts
      if (audioCtxRef.current) {
        audioCtxRef.current.close();
      }
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [stream, isRecording , paused ]);

  const drawWaveform = () => {
    const canvas = canvasRef.current;
    const canvasCtx = canvas.getContext("2d");
    const analyser = analyserRef.current;

    const bufferLength = analyser?.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    const draw = () => {
      analyser.getByteTimeDomainData(dataArray);

      // Clear the canvas
      canvasCtx.clearRect(0, 0, canvas.width, canvas.height);

      // Set up the canvas properties
      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = '#3D5F8F';
      canvasCtx.beginPath();

      const sliceWidth = (canvas.width * 1.0) / bufferLength;
      let x = 0;

      // Draw the waveform
      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128.0;
        const y = (v * canvas.height) / 2;

        if (i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      canvasCtx.lineTo(canvas.width, canvas.height / 2);
      canvasCtx.stroke();

      animationFrameRef.current = requestAnimationFrame(draw); // Keep redrawing the waveform
    };

    draw(); // Start the first draw
  };

  return <canvas ref={canvasRef} width="500" height="100" style={{  }} />;
};

export default WaveformVisualizer;